<div class="login-viewport">
  <mat-card class="login-card">
    <div class="logo-container">
      <img src="assets/images/logo.png" alt="Logo Esse 3" />
    </div>

    <h1>Reimposta Password</h1>
    <p class="subtitle">
      Inserisci l'indirizzo email del tuo account utente e ti invieremo
      un link per reimpostare la password.
    </p>

    <form [formGroup]="form" (ngSubmit)="submit()" novalidate>
      <!-- EMAIL -->
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Indirizzo email</mat-label>
        <input
          matInput
          type="email"
          formControlName="email"
          autocomplete="email"
        />
        <mat-icon matPrefix fontSet="material-icons-outlined">mail</mat-icon>

        <mat-error *ngIf="f.email.touched && f.email.errors?.['required']">
          Inserisci l'indirizzo email.
        </mat-error>
        <mat-error *ngIf="f.email.touched && f.email.errors?.['email']">
          Indirizzo email non valido.
        </mat-error>
      </mat-form-field>

      <!-- SUBMIT -->
      <button
        esse-button
        variant="primary"
        class="w-100 btn-submit"
        [disabled]="form.invalid || loading"
      >
        <ng-container *ngIf="!loading; else loadingTpl">
          Invia link di reset
        </ng-container>
      </button>

      <ng-template #loadingTpl>
        <span class="btn-loading">
          <mat-progress-spinner diameter="18" mode="indeterminate"></mat-progress-spinner>
          <span>Invio in corso…</span>
        </span>
      </ng-template>

      <!-- SUCCESS -->
      <div class="success" *ngIf="success">
        <mat-icon>check_circle</mat-icon>
        Email inviata! Controlla la tua casella di posta.
      </div>

      <!-- ERROR -->
      <div class="error" *ngIf="error">
        <mat-icon>error_outline</mat-icon>
        {{ error }}
      </div>

      <a class="back-link" routerLink="/login">Torna al login</a>
    </form>
  </mat-card>
</div>
